import React from "react";
import ATable from "../../common/table";

const CaseRequestsTable = props => {
  //Column Definition
  const columns = [
    {
      header: "S/N",
      id: "s-n",
      render: row => <div>{props.paginatedCallBack(row.viewIndex)}</div>,
      width: 50
    },
    {
      header: "Message ID",
      accessor: "messageId"
    },
    {
      header: "Case Number",
      accessor: "caseNumber"
    },
    {
      header: "Transaction Reference",
      accessor: "transactionReference"
    },
    {
      header: "Request Type",
      accessor: "requestType"
    },
    {
      header: "Response Message",
      accessor: "responseMessage"
    },
    {
      header: "Status",
      accessor: "status"
    },
    {
      header: "Domain",
      accessor: "domain"
    },
    {
      header: "Created By",
      accessor: "createdBy"
    },
    {
      header: "Created On",
      accessor: "createdOn"
    },
    {
      header: "Last Updated On",
      accessor: "lastUpdatedOn"
    }
  ];
  return (
    <ATable
      className="-striped -highlight"
      tableData={props.tableData}
      columns={columns}
      loading={props.loading}
      onRowClick={props.onRowClick}
      onChange={props.onTableChange || null}
      manual
      {...props}
    />
  );
};

export default CaseRequestsTable;



// WEBPACK FOOTER //
// ./src/components/discover/caseRequests/CaseRequestsTable.js